import GameReportPage from "./game-report-page";

export default GameReportPage